import React from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { _ } from '_locales';
import moment from 'moment';

import { calendar as calendarSetup } from '_actions';

import EventsDay from './EventsDay';

// import style
const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const Table = styled.table`
    width: 100%;
    border-collapse: separate;
    border-spacing: 0px 0px;
    border: 1px solid #eee;
    margin-top: 10px;
    table-layout: fixed;

    ${(parentWidth < 501) && css`
      border-spacing: 0px 0px;
  
      .span-responsive-mode {
          text-align: center;
      }
    `};
`;

const Span = styled.span`
  font-size: 16px !important;
  text-align: left !important; 
  font-weight: 500 !important;
  display: block;
  margin: 0 0 8px;
`;

const Td = styled.td`
    height: 130px !important;
    position: relative;
    vertical-align:top;
    width: 6%;
    padding: 5px;
    box-sizing: border-box;
    box-shadow: 0 0 0 1px #eee;

    ${(parentWidth < 501) && css`
      height: 40px !important;

      span {
          text-align: center;
      }
    `};
`;
// End style

const CalendarTable = ({
  disabled,
  dateContext,
  collection,
  setEventInfo,
  month,
  curYear,
  currentMonthEvents,
  prevMonthsEvents,
  nextMonthsEvents
}) => {
  const responsiveWeekDays = [
    { day: _('reminder.sun'), id: 0 },
    { day: _('reminder.mon'), id: 1 },
    { day: _('reminder.tue'), id: 2 },
    { day: _('reminder.wed'), id: 3 },
    { day: _('reminder.thu'), id: 4 },
    { day: _('reminder.fri'), id: 5 },
    { day: _('reminder.sat'), id: 6 },
  ];

  const daysInMonth = () => dateContext.daysInMonth();

  const daysInPrevMonth = () => moment(dateContext).subtract(1, 'month').daysInMonth();

  const firstDayOfMonth = () => {
    const firstDay = moment(dateContext).startOf('month').format('d'); // Day of week: 0, ... ,6
    return firstDay;
  };

  const lastDayOfMonth = () => {
    const lastDay = moment(dateContext).endOf('month').format('d'); // Day of week: 0, ... ,6
    return lastDay;
  };

  /**
   * Calculate the first blank days in calendar
   */
  const prevDaysBlanks = [];
  for (let i = firstDayOfMonth(); i > 0; i -= 1) {
    const totalObject = { ...prevMonthsEvents };
    if (daysInPrevMonth() - (i - 1) in totalObject) {
      prevDaysBlanks.push(
        <EventsDay
          key={`${i}-${Math.random()}`}
          i={daysInPrevMonth() - (i - 1)}
          disabled={disabled}
          collection={collection}
          setEventInfo={setEventInfo}
          allEventsObj={prevMonthsEvents}
          month={month}
          curYear={curYear}
          prevNextCurr="prev"
        />
      );
    } else {
      prevDaysBlanks.push(
        <Td key={`${i}-${Math.random()}`} style={{ backgroundColor: '#e3e3e3' }}>
          <Span style={{ color: '#636363' }}>{daysInPrevMonth() - (i - 1)}</Span>
        </Td>
      );
    }
  }

  /**
   * Calculate the last blank days in calendar
   */
  const nextDaysBlanks = [];
  for (let i = 0; i < 6 - lastDayOfMonth(); i += 1) {
    const totalObject = { ...nextMonthsEvents };
    if (i + 1 in totalObject) {
      nextDaysBlanks.push(
        <EventsDay
          key={`${i}-${Math.random()}`}
          i={i + 1}
          disabled={disabled}
          collection={collection}
          setEventInfo={setEventInfo}
          allEventsObj={nextMonthsEvents}
          month={month}
          curYear={curYear}
          prevNextCurr="next"
        />
      );
    } else {
      nextDaysBlanks.push(
        <Td key={`${i}-${Math.random()}`} style={{ backgroundColor: '#e3e3e3' }}>
          <Span style={{ color: '#636363' }}>{i + 1}</Span>
        </Td>
      );
    }
  }

  const fullDaysInMonth = [];
  for (let i = 1; i <= daysInMonth(); i += 1) {
    const totalObject = { ...currentMonthEvents };
    if (i in totalObject) {
      fullDaysInMonth.push(
        <EventsDay
          key={`${i}-${Math.random()}`}
          i={i}
          disabled={disabled}
          collection={collection}
          setEventInfo={setEventInfo}
          allEventsObj={currentMonthEvents}
          month={month}
          curYear={curYear}
          prevNextCurr="curr"
        />
      );
    } else {
      fullDaysInMonth.push(
        <Td key={`${i}-${Math.random()}`} style={{ backgroundColor: '#fff' }}>
          <Span style={{ color: '#717171' }}>{i}</Span>
        </Td>
      );
    }
  }

  const totalSlots = [...prevDaysBlanks, ...fullDaysInMonth, ...nextDaysBlanks];
  const rows = [];
  let cells = [];

  totalSlots.forEach((row, i) => {
    if ((i % 7) !== 0) {
      cells.push(row);
    } else {
      const insertRow = cells.slice();
      rows.push(insertRow);
      cells = [];
      cells.push(row);
    }
    if (i === totalSlots.length - 1) {
      const insertRow = cells.slice();
      rows.push(insertRow);
    }
  });

  return (
    <Table>
      <tbody>
        <tr>
          {
            responsiveWeekDays.map(({ day, id }) => (
              <th scope="col" key={id} style={{ padding: '0 10px', backgroundColor: '#fff', textAlign: 'left' }}>
                <Span className="span-responsive-mode" style={{ color: '##000000', fontSize: '14px' }}>{(parentWidth < 501) ? day.charAt(0) : day}</Span>
              </th>
            ))
          }
        </tr>

        {rows.map((day) => (<tr key={`${day}-${Math.random()}`}>{day}</tr>))}

      </tbody>
    </Table>
  );
};

const mapStateToProps = (state) => ({
  collection: state.config.collection,
});

const mapDispatchToProps = (dispatch) => ({
  setEventInfo: (eventInfo) => dispatch(calendarSetup.setEventInfo(eventInfo)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarTable);
